var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapMain"},[_c('div',{ref:"amap",attrs:{"id":"amap"}}),_c('zoom',{ref:"zoom"}),_c('toolbar',{ref:"Toolbar"}),_c('layerWms',{ref:"layerWms",attrs:{"layers":_vm.layers}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }